import { Navigate } from 'react-router-dom';
import { auth } from 'routes/config';
import { getCookie } from 'utils/helperFunctions';
import { CacheKeys } from 'utils/cacheKeys';

type Props = { outlet: JSX.Element };

export default function PrivateRoute({ outlet }: Props) {
  const isAuthenticated = Boolean(getCookie(CacheKeys.authToken));
  const useStatus = getCookie(CacheKeys.userStatus);
  const isAllowedToUser = useStatus === 'true';
  if (isAuthenticated && isAllowedToUser) {
    return outlet;
  } else {
    return <Navigate to={`${auth.base}/${auth.logout}`} state={window.location.href} />;
  }
}
